import type { SuggestedAmountFromBackend } from '@practist/components/PaymentForm/paymentFormReducer';

export const formatSuggestedAmountDescription = (
  suggestedAmount: SuggestedAmountFromBackend,
): string => {
  if (!suggestedAmount.invoiceFinalizedTimestamp) {
    return suggestedAmount.description;
  }

  const invoiceDate = new Date(suggestedAmount.invoiceFinalizedTimestamp);
  if (Number.isNaN(invoiceDate.getTime())) {
    return suggestedAmount.description;
  }

  const invoiceDateLabel = invoiceDate.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  });
  const paymentsReceivedCents =
    suggestedAmount.paymentsReceivedSinceInvoiceCents ?? 0;
  if (paymentsReceivedCents <= 0) {
    return `From your ${invoiceDateLabel} invoice.`;
  }

  const paymentsReceived = (paymentsReceivedCents / 100).toLocaleString(
    'en-US',
    { minimumFractionDigits: 2, maximumFractionDigits: 2 },
  );
  return `From your ${invoiceDateLabel} invoice (after $${paymentsReceived} in payments already received).`;
};
